/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { deleteCookie, getCookieData } from '../utils';

export type ShareVueCookieType = {
  auth?: {
    accessToken: string;
    email: string;
    defaultLibraryId: string;
    familyName: string;
    givenName: string;
    initials: string;
    name: string;
    orgCode: string;
    orgId: string;
    orgName: string;
    orgRole: string;
    readableLibraries: {
      id: string;
      name: string;
    }[];
    samAccountName: string | null;
    sessionId: string;
    sourceApp: string;
    title: string | null;
    userCreatedAt: string;
    userId: string;
    writableLibraries: string[];
  };
  error?: string;
  pearl_env?: string;
};

const getShareVueCookieData_ = () => {
  console.log('Cookie data:', JSON.stringify(document.cookie));

  const cookieData = getCookieData('share-vue');

  if (!cookieData) {
    console.log('No share-vue cookie found');
    return undefined;
  }
  let ret = JSON.parse(window.atob(cookieData));
  if (ret.json) ret = ret.json;
  console.log('share-vue cookie found', cookieData, ret);
  return { ...ret } as ShareVueCookieType;
};

(window as any).shareVueCookieData = getShareVueCookieData_();

export const getShareVueCookieData = () => {
  return (window as any).shareVueCookieData as Partial<ShareVueCookieType> | undefined;
};

export const deleteShareVueCookieData = () => {
  (window as any).shareVueCookieData = undefined;
  deleteCookie('share-vue');
};
